import { useMemo } from 'react';
import { useOptionsQuery } from '../../services/api';

/**
 * Pick-lists, read from the API.
 *
 * These replace the selectors the old options slice exposed. Every caller shares one
 * cache key, so the lead form, the pipeline and the users page cost a single request
 * between them — and adding a source in Settings shows up in the lead form at once,
 * because the mutation invalidates the tag they all read.
 */

/** One list by key: 'titles' | 'genders' | 'roles' | 'stages' | 'sources' | 'tests'. */
export function useOptionList(key) {
  const { data } = useOptionsQuery();
  // a stable [] while loading, so a dependent useMemo doesn't churn every render
  return useMemo(() => data?.[key] || EMPTY, [data, key]);
}

const EMPTY = [];

export const STAGE_PAL = ['var(--muted)', 'var(--s1)', 'var(--s3)', 'var(--s4)', 'var(--s2)', 'var(--s1)', 'var(--s3)'];

/** Won and Lost are terminal, so they get outcome colours rather than a palette slot. */
export const stageColorOf = (name, i) =>
  name === 'Won' ? 'var(--good)' : name === 'Lost' ? 'var(--crit)' : STAGE_PAL[i % STAGE_PAL.length];

/** Pipeline stages paired with their column colour: `[{ k, c }]`. */
export function useStages() {
  const stages = useOptionList('stages');
  return useMemo(() => stages.map((k, i) => ({ k, c: stageColorOf(k, i) })), [stages]);
}
